import {postRequest} from "./helper"
export const resumeSendTo = (data) => postRequest('send_resume',data);
export const resumeList = (data) => postRequest('resume_list',data);
export const deleteResumeApi = (data) => postRequest('resume_delete',data);





// WEBPACK FOOTER //
// ./src/api/SendResume.js